<template>
  <button
    :style="{
      left: propLeft,
      top: propTop,
      right: propRight,
      bottom: propBottom,
      width: propWidth,
      height: propHeight,
    }"
    :class="className"
    class="function-button">
    <slot name="icon"></slot>
  </button>
</template>

<script>
export default {
  name: "FunctionButton",
  data() {
    return {}
  },
  props: {
    className: {
      type: Array,
      default() { return [] }
    },
    plain: {
      type: Boolean,
      default: true,
    },
    propLeft: {
      type: String
    },
    propTop: {
      type: String
    },
    propRight: {
      type: String
    },
    propBottom: {
      type: String
    },
    propWidth: {
      type: String
    },
    propHeight: {
      type: String
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
  },
};
</script>

<style scoped>
.function-button {
  position: absolute;
  cursor: pointer;
  background-color: transparent;
  /* background-color: gold; */
  opacity: .8;
  border: none;
  outline: none;
  padding: 0;
}
.function-button.success {
  background-color: rgba(0, 66, 119, 0.8);
  border: 1px solid #2f67a0;
  border-radius: 5px;
}

.function-button:focus > .back-image {
  transform: translateX(-10px);
}
</style>
